import React, { useEffect, useState } from 'react'
import { ScrollView, Platform } from 'react-native'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { atlTheme } from '../../atlTheme'
import { ATLIconizedText, ATLSpacing, SpacingSizesEnum } from '@appsimples/atlantica-react-native'
import { icons } from '../../constants/searchAssets'
import { ConstructionDocumentsList } from './ConstructionDocumentsList'
import { ConstructionModuleSelector } from '../../components/ConstructionModuleSelector'
import { CardContainer } from './components/GenericComponents'
import styled from 'styled-components/native'
import { useConstructionData } from '../../utils/hooks/useConstructionData'
import { Loading } from '../../components/loading/Loading'
import { checkAndroidWriteExternalStoragePermission, askAndroidDowloadPermission } from '../../utils/downloadFile'
import { getAddressToDisplay } from './utils/getAddress'

const Container = styled.View`
  background-color: ${atlTheme.ColorSurface};
  border-radius: 10px;
`

export const ConstructionDocumentsScreen = ({}) => {
  const { constructionData, isFetchingConstructionData } = useConstructionData()
  const addressToDisplay = getAddressToDisplay(constructionData?.construction?.constructionSpecificAddress)
  const [documentsData, setDocumentsData] = useState({})

  const getDocuments = () => {
    const listDocumentsUrl = constructionData?.construction?.documents?.reduce((obj, document) => {
      obj[document.documentType] = document.url
      return obj
    }, {})
    return listDocumentsUrl || {}
  }

  useEffect(() => {
    setDocumentsData(getDocuments())
  }, [constructionData])

  useEffect(() => {
    if (Platform.OS === 'android') {
      checkAndroidWriteExternalStoragePermission().then(permissionGranted => {
        !permissionGranted && askAndroidDowloadPermission()
      })
    }
  }, [])

  return (
    <ScrollView>
      {isFetchingConstructionData ? (
        <>
          <ATLSpacing type={SpacingSizesEnum.marginal} />
          <Loading />
        </>
      ) : (
        <>
          <CardContainer>
            <ConstructionModuleSelector />
          </CardContainer>
          <ATLSpacing type={SpacingSizesEnum.base} />
          <Container>
            <ATLIconizedText
              icon={icons.building}
              iconBaseProps={{
                tintColor: atlTheme.ColorBrand2Default,
              }}
              text={constructionData?.constructionUnit?.name}
              labelBaseProps={{ multilineLimit: 2 }}
              horizontalMargin={atlTheme.SpacingMarginal}
            />
            <ATLIconizedText
              icon={icons.location}
              iconBaseProps={{
                tintColor: atlTheme.ColorBrand2Default,
              }}
              text={addressToDisplay}
              labelBaseProps={{ multilineLimit: 2 }}
              horizontalMargin={atlTheme.SpacingMarginal}
            />
          </Container>
          <ATLSpacing type={SpacingSizesEnum.marginal} />
          <Container>{documentsData && <ConstructionDocumentsList documentsUrl={documentsData} />}</Container>
        </>
      )}
    </ScrollView>
  )
}
